export default __webpack_public_path__ + "86e8f02be6f7723841f59af9d62a1dd7.svg";